'use client';

import { toast } from '@/hooks/use-toast';
import axios from 'axios';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

/**
 * Global safety net for unhandled 500 errors.
 *
 * When the axios interceptor rejects 500 responses, call sites without
 * try-catch would produce unhandled promise rejections.  This component
 * catches those and shows a user-friendly toast instead.
 */
export default function GlobalErrorHandler() {
  const t = useTranslations('ResearchPage');

  useEffect(() => {
    const handler = (event: PromiseRejectionEvent) => {
      if (
        axios.isAxiosError(event.reason) &&
        event.reason.response?.status === 500
      ) {
        event.preventDefault();
        toast({
          description: t('errorMessages.serverError'),
          variant: 'destructive',
          duration: 3000,
        });
      }
    };

    window.addEventListener('unhandledrejection', handler);
    return () => window.removeEventListener('unhandledrejection', handler);
  }, [t]);

  return null;
}
